import { DadosGerais } from './DadosGerais';
import { Jurisdicionado } from './Jurisdicionado';

export class Pca {
    id: string;
    codPca: string;
    codProtocolo: number;
    dsAnoexercicio: number;
    status: number;
    jurisdicionado: Jurisdicionado;
    dadosGerais: DadosGerais;
    modulos: any[];

    responsavel: any;
    idStatus: any;
    idArquivoProtocolo: any;
    idProtocoloGeral: any;
    idProtocoloGeralRatificado: any;
    idCertificado: any;
    flAssinado = false;
    flRatificacaoAssinada = false;

    constructor(PCAInfo: any = null) {
        if (PCAInfo != null) {
            this.id = PCAInfo.id;
            this.codPca = PCAInfo.codPca;
            this.codProtocolo = PCAInfo.codProtocolo;
            this.dsAnoexercicio = PCAInfo.dsAnoexercicio;
            this.status = PCAInfo.status;

            this.responsavel = PCAInfo.responsavel;
            this.idStatus = PCAInfo.idStatus;
            this.idArquivoProtocolo = PCAInfo.idArquivoProtocolo;
            this.idProtocoloGeral = PCAInfo.idProtocoloGeral;
            this.idProtocoloGeralRatificado = PCAInfo.idProtocoloGeralRatificado;
            this.idCertificado = PCAInfo.idCertificado;
            this.flAssinado = PCAInfo.flAssinado;
            this.flRatificacaoAssinada = PCAInfo.flRatificacaoAssinada;
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/Pca.ts